export default __webpack_public_path__ + "static/media/gdf.9ec49d9c.jpg";